import { tw } from "@careinfo/tailwind";
import { CellContext } from "@tanstack/react-table";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { useSearchParams, type SetURLSearchParams } from "react-router-dom";
import Modal from "../Modal";
import { OrderDetailPage } from "@careinfo/layout";

export interface Props<T = any, V = any> extends CellContext<T, V> {
  getValue: any;
  row: any;
  children?: ReactNode;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  [key: string]: any;
}

const TrackingCell: React.FC<Props> = ({ getValue, row, children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedOrder, setSelectedOrder] = useState(
    searchParams.get("selectedItem")
  );
  const orderId = row?.original?.order
    ? row?.original?.order?.id
    : row?.original?.id;
  const [isOrderDetailsModalOpen, setIsOrderDetailsModalOpen] = useState(
    searchParams.get("selectedItem") === orderId
  );

  useEffect(() => {
    const order = { selectedItem: searchParams.get("selectedItem") };
    setSelectedOrder(order.selectedItem || "");
    setIsOrderDetailsModalOpen(order.selectedItem === orderId);
  }, [searchParams, selectedOrder, orderId]);

  const handleClose = useCallback(() => {
    setIsOrderDetailsModalOpen(false);
    const clonedSearchParams = new URLSearchParams(searchParams);
    clonedSearchParams.delete("selectedItem");
    setSearchParams(clonedSearchParams);
    setSelectedOrder(null);
  }, [searchParams, setSearchParams]);

  return (
    <>
      <button
        onClick={() => {
          const clonedSearchParams = new URLSearchParams(searchParams);
          clonedSearchParams.set("selectedItem", orderId);
          setSearchParams(clonedSearchParams);
        }}
        className={tw`cursor-pointer focus:outline-none`}
      >
        {getValue() ?? "N/A"}
        {children}
      </button>
      {!!searchParams.get("selectedItem") && (
        <Modal
          isOpen={isOrderDetailsModalOpen}
          onClose={handleClose}
          title="Order Details"
        >
          <OrderDetailPage selectedOrder={selectedOrder} />
        </Modal>
      )}
    </>
  );
};

export default TrackingCell;
